import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsOverview = ({ language, direction }) => {
  const stats = [
    {
      id: 1,
      labelEn: 'Total Users',
      labelFr: 'Total des utilisateurs',
      labelAr: 'إجمالي المستخدمين',
      value: '6',
      change: '+1',
      changeType: 'increase',
      icon: 'Users',
      color: 'primary'
    },
    {
      id: 2,
      labelEn: 'Active Sessions',
      labelFr: 'Sessions actives',
      labelAr: 'الجلسات النشطة',
      value: '4',
      change: '+2',
      changeType: 'increase',
      icon: 'Activity',
      color: 'success'
    },
    {
      id: 3,
      labelEn: 'Administrators',
      labelFr: 'Administrateurs',
      labelAr: 'المسؤولون',
      value: '1',
      change: '0',
      changeType: 'neutral',
      icon: 'Shield',
      color: 'error'
    },
    {
      id: 4,
      labelEn: 'System Uptime',
      labelFr: 'Disponibilité du système',
      labelAr: 'وقت تشغيل النظام',
      value: '99.9%',
      change: '+0.1%',
      changeType: 'increase',
      icon: 'Server',
      color: 'accent'
    }
  ];

  const getLabel = (stat) => {
    if (language === 'fr') return stat?.labelFr;
    if (language === 'ar') return stat?.labelAr;
    return stat?.labelEn;
  };

  const getColorClasses = (color) => {
    switch (color) {
      case 'primary':
        return 'bg-primary/10 text-primary';
      case 'success':
        return 'bg-success/10 text-success';
      case 'error':
        return 'bg-error/10 text-error';
      case 'accent':
        return 'bg-accent/10 text-accent';
      default:
        return 'bg-primary/10 text-primary';
    }
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6" style={{ direction }}>
      {stats?.map((stat) => (
        <div key={stat?.id} className="bg-card border border-border rounded-lg p-4 md:p-6 hover:shadow-elevation-md transition-all duration-250">
          <div className="flex items-start justify-between mb-4">
            <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${getColorClasses(stat?.color)}`}>
              <Icon name={stat?.icon} size={24} />
            </div>
            {stat?.changeType !== 'neutral' && (
              <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${
                stat?.changeType === 'increase' ? 'bg-success/10 text-success' : 'bg-error/10 text-error'
              }`}>
                <Icon name={stat?.changeType === 'increase' ? 'TrendingUp' : 'TrendingDown'} size={12} />
                {stat?.change}
              </span>
            )}
          </div>
          <div>
            <p className="text-2xl md:text-3xl font-bold text-foreground mb-1">{stat?.value}</p>
            <p className="text-sm text-muted-foreground">{getLabel(stat)}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsOverview;